import { currentUserId, rememberedActiveBusiness } from "@/components/SavedAssets";

// Generator form drafts belong to the business they were typed under, the
// way documents and notifications do - an employee applied while operating
// one business must not surface in another's form. The primary business
// keeps the legacy un-suffixed key so existing drafts survive; Express and
// guests (no remembered business) are untouched.
export function bizDraftKey(baseKey) {
  const biz = rememberedActiveBusiness(currentUserId());
  return biz && biz.id && !biz.primary ? `${baseKey}:${biz.id}` : baseKey;
}
